module.exports = __webpack_public_path__ + "img/clean-table.831d9349.svg";